export enum PreregistrationVersion {
  VERSION_0_NULL = 0,
  VERSION_2 = 2,
}
